export class MobileInformation {
    oSType: string;
    oSVersion: string;
    deviceModel: string
    browser: string;
    appVersion: string;
    timeZone: string;
    mDMLocationKey: string;
}